import React, { useContext, useState } from 'react';

import { EventsContext } from '../EventsContext';
import PredicateChain from '../../../common/PredicateChain';

import { ButtonBase, Tooltip } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

import Macros from '../../../common/Macros';

import { editRstMacroArgs } from '../../../utils';

import { cloneDeep } from '../../../utils/lodash';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import LoaderNew from '../../../common/LoaderNew';

import EventsStyles from '../EventsStyles';
import CommonStyles from '../../../common/CommonStyles';
import ActionConfirmation from '../../../common/ActionConfirmation';

const useStyles = makeStyles({
  ...CommonStyles,
  ...EventsStyles,
});

const EventByMacros = (props) => {
  const {
    macro_types,
    updateEvent,
    deleteEvent,
    openRstToEditEvent,
    addNodeToNodesData,
  } = useContext(EventsContext);
  const [saveLoading, setSaveLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [sub, setSub] = useState(props.sub);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const classes = useStyles({});

  const eventIsUnsaved = !sub.id;

  const deleteJelModal = {
    contentText: 'Delete',
    contentBoldText: `${sub.id} ${sub.type}  event?`,
    open: showDeleteModal,
  };

  const saveMacrosEvent = () => {
    setSaveLoading(true);

    updateEvent(props.ancestor, sub.type, sub, (updatedSub) => {
      setSub(updatedSub);

      setEditable(false);
      setSaveLoading(false);
    });
  };

  const setFunctionPerfValues = (type, value) => {
    setSub({
      ...sub,
      macro: {
        ...sub.macro,
        [type]: value,
      }
    });
  };

  const addFunctionPerfArguments = (index = -1, argumentName = '', value = '') => {
    const subCopy = cloneDeep(sub);

    editRstMacroArgs(index, argumentName, value, subCopy.macro);

    setSub(subCopy);
  };

  const onArgRemove = (index) => {
    const subCopy = cloneDeep(sub);

    subCopy.macro.args.splice(index, 1);
    if (!subCopy.macro.args.length) delete subCopy.macro.args;

    setSub(subCopy);
  };

  return (
    <React.Fragment>
      <ActionConfirmation
        modalData={deleteJelModal}
        acceptHandler={() => {
          deleteEvent(props.ancestor, sub.type, sub.id);
          setShowDeleteModal(false);
          setEditable(false);
        }}
        onClose={() => setShowDeleteModal(false)}
      />

      <div className={classes.row} style={{background: editable ? '#DBD6E5' : '#FBFBFB'}}>
        <div className={`${classes.rowContent} ${classes.mb5}`}>
          <div style={{width: '20px', marginRight: '10px'}}>
            <span className={classes.subId}>{sub.id}</span>
          </div>

          <div>
            <div className={classes.predCol}>
              <PredicateChain
                rst={sub.subscriber}
                maxSelectedRstCount={1}
                ancestor={props.ancestor}
                mode={'show'}
              />
            </div>

            <div className={classes.mt10}>
              <Macros
                showArgs={true}
                showCode={true}
                macro={sub.macro}
                showAsync={true}
                showScriptType={true}
                showReturnType={true}
                editable={editable}
                nodes={props.nodesData}
                macro_types={macro_types}
                onArgRemove={onArgRemove}
                addNodeToState={addNodeToNodesData}
                oldMacro={(props.sub.macro && props.sub.macro.code) || ''}
                functionVal={(sub.macro && sub.macro.code) || ''}
                scriptType={(sub.macro && sub.macro.script_type) || ''}
                returnType={(sub.macro && sub.macro.return_type) || ''}
                funcArguments={(sub.macro && sub.macro.args) || ''}
                setFunctionPerfValues={setFunctionPerfValues}
                addFunctionPerfArguments={addFunctionPerfArguments}
              >
              </Macros>
            </div>
          </div>

          <div className={classes.editRowCol}>
            <div className={classes.ml20}>
              {!editable && (
                <Tooltip
                  title="Edit"
                  placement="top"
                  classes={{
                    tooltip: classes.muiTooltip,
                  }}
                >
                  <EditIcon
                    onClick={() => {
                      setEditable(true);
                    }}
                  />
                </Tooltip>
              )}
              <Tooltip
                title="Open predicate to edit"
                placement="top"
                classes={{
                  tooltip: classes.muiTooltip,
                }}
                style={{ marginTop: '20px' }}
              >
                <OpenInNew
                  onClick={() => {
                    openRstToEditEvent(props.ancestor, sub.subscriber);
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>

        {editable ? (
          <div className={classes.rowButtonsContainer}>
            {!eventIsUnsaved ? (
              <ButtonBase
                className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
                onClick={() => {
                  setShowDeleteModal(true);
                }}
              >
                <span>Delete</span>

                <DeleteIcon className={classes.deleteRowIcon} />
              </ButtonBase>
            ) : <div />}

            <div className={classes.alignCenter}>
              <ButtonBase
                className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr20}`}
                onClick={() => {
                  setEditable(false);
                  setSub(cloneDeep(props.sub));
                }}
              >
                Cancel
              </ButtonBase>
              <ButtonBase
                className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnNormal}`}
                onClick={() => {
                  saveMacrosEvent();
                }}
              >
                {saveLoading ? <LoaderNew /> : 'Save'}
              </ButtonBase>
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  )
}

export default EventByMacros;



